// extracted by mini-css-extract-plugin
module.exports = {"status":"retailer-edit_status_1A1R3"};